import React from "react";
import PricingSection from "./../components/PricingSection";

function PricingPage(props) {
  return (
    <PricingSection
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Pricing"
      subtitle=""
    ></PricingSection>
  );
}

export default PricingPage;
